export interface SipAccountDto {
  id?: string;
  name?: string | null;
  username?: string | null;
  password?: string | null;
  server?: string | null;
  prefix?: string | null;
  default?: boolean;
  registerEnabled?: boolean;
  outboundProxy?: string | null;
  expiry?: string;
  registrarHost?: string | null;
  accountAor?: string | null;
  displayName?: string | null;
  contactUri?: string | null;
  sendUsernameInContact?: boolean;
  customHeaders?: string[] | null;
  registrationTimeout?: string;
  failureRetryInterval?: string;
  maxRegisterAttempts?: number;
  exitOnUnequivocalFailure?: boolean;
  allowHeader?: string | null;
}

export interface SipAccount extends SipAccountDto {
  tenantId?: string | null;
  deleted?: boolean;
}

export interface UpdateSipAccountsRequest {
  sipAccounts: SipAccountDto[];
}

export const toSipAccountDto = (
  account:
    | SipAccount
    | SipAccountDto
    | (Partial<SipAccountDto> & Record<string, unknown>),
): SipAccountDto => {
  const {
    id,
    name,
    username,
    password,
    server,
    prefix,
    default: isDefault,
    registerEnabled,
    outboundProxy,
    expiry,
    registrarHost,
    accountAor,
    displayName,
    contactUri,
    sendUsernameInContact,
    customHeaders,
    registrationTimeout,
    failureRetryInterval,
    maxRegisterAttempts,
    exitOnUnequivocalFailure,
    allowHeader,
  } = account;

  return {
    id,
    name,
    username,
    password,
    server,
    prefix,
    default: isDefault,
    registerEnabled,
    outboundProxy,
    expiry,
    registrarHost,
    accountAor,
    displayName,
    contactUri,
    sendUsernameInContact,
    customHeaders,
    registrationTimeout,
    failureRetryInterval,
    maxRegisterAttempts,
    exitOnUnequivocalFailure,
    allowHeader,
  };
};

export const toUpdateSipAccountsRequest = (
  sipAccounts: Array<SipAccount | SipAccountDto>,
): UpdateSipAccountsRequest => ({
  sipAccounts: sipAccounts.map(toSipAccountDto),
});
